import "./Home.css";
import TopBar from "../../_common/topbar/TopBar";
import Vegas from "../../_common/Vegas/Vegas";
import {
  Loader,
  sample,
  add_shopping_cart,
  close,
} from "../../../assets/images";
import useHome from "./useHome";
import { useLocation } from "react-router";
import { commaValidation } from "../../../utility";
import { withTranslation } from "react-i18next";
import { useState } from "react";
import { Modal } from "@mui/material";

const Home = (props) => {
  const { t } = props;

  const location = useLocation();

  const {
    selectRoom,
    addRoom,
    updateRoom,
    AddRoomCart,
    closeModal,
    handleChangeAdult,
    handleChange,
    proceedBtn,
    deleteRoom,
    handleChildAgeChange,
    editDetails,
    roomList,
    user_id,
    loader,
    initialRoom,
    notAvailable,
    selectedRoomCount,
    selectedAdultCount,
    selectedChildrenCount,
    singleRoomDetail,
    childrenCount,
    adultcount,
    removeRooms,
    childrenAges,
    roomsDatassss,
    addedPersons,
    differenceDate,
    childAgeSelected,
    modalRenderTrigger,
    updateClicked,
    tempAdultCount,
    tempRoomCount,
    startTime,
    childArrayAge,
    endTime,
    cartData,
    selectAdultEdit,
    adultLengthDisplay,
    childrenLengthDisplay,
    closeModalEdit,
    selectChildrenEdit,
    nutralCheckIn,
    nutralCheckOut,
    AdultCountLoc,
    RoomCountLoc,
  } = useHome(location, t);

  const handleDelete = () => {
    const deleteval = [...adultcount];
    // deleteval.splice(i, 1);
    // setAdultcount(deleteval);
  };

  /**
   * render the top bar which is common for all pages
   * @returns
   */
  const renderTopBar = () => {
    return <TopBar />;
  };

  /**
   * render vegas bar
   * @returns
   */
  const renderVegasBar = () => {
    return <Vegas />;
  };

  /**
   * render main screen
   * @returns
   */
  const renderMainRoom = () => {
    return (
      <div className="main_choose flt">
        <div className="choose_room flt">{t("Choose_Your_Room")}</div>
        {loader === "loading" && (
          <div className="main_load ">
            <img src={Loader} alt="loader" />
          </div>
        )}
        {loader !== "loading" && (
          <div className="main_row home_row flt">
            <div className="row room_show">
              {roomList &&
                roomList.map((data) => (
                  <div className="col-sm-4">
                    <div className="main_room_image flt">
                      <div className="room_image flt">
                        <img
                          src={
                            data?.room_image[0]
                              ? `${process.env.REACT_APP_MEDIA_DOMAIN}${data?.room_image?.[0]}`
                              : sample
                          }
                          alt="no_image"
                        />

                        <div className="main_standerd flt">
                          {data?.room_type?.[0]?.room_type
                            ? data?.room_type?.[0]?.room_type
                            : data?.room_type}
                        </div>
                      </div>
                      <ul className="main_wifi1_det flt">
                        {data &&
                          data?.amenities.map((res) => (
                            <li>
                              <img
                                src={`${process.env.REACT_APP_MEDIA_DOMAIN}${res?.amenities_image}`}
                              />
                              <span>{res?.amenities}</span>
                            </li>
                          ))}
                      </ul>
                      {nutralCheckIn &&
                      nutralCheckOut &&
                      AdultCountLoc &&
                      RoomCountLoc &&
                      new Date(location?.state?.checkindate) <
                        new Date(location?.state?.checkoutdate) &&
                      localStorage.getItem("datetimes") &&
                      localStorage.getItem("datetimes1") ? (
                        <div className="price_flex flt">
                          Available Rooms :{" "}
                          {data?.available_rooms < 0
                            ? 0
                            : data?.available_rooms}
                        </div>
                      ) : (
                        ""
                      )}
                      <div className="price_flex flt">
                        {nutralCheckIn &&
                          nutralCheckOut &&
                          AdultCountLoc &&
                          RoomCountLoc && (
                            <div className="main_discount flt">
                              <div className="room_rates">
                                {(data?.actual_price || data?.price) &&
                                  `₹ ${commaValidation(
                                    Number(
                                      data?.actual_price
                                        ? data?.actual_price
                                        : data?.price
                                    ).toFixed(2)
                                  )}`}
                              </div>
                            </div>
                          )}

                        <div className="main_select flt">
                          {initialRoom ? (
                            <button className={"select_room notClickable"}>
                              {t("Select_Room")}
                            </button>
                          ) : selectedRoomCount > 1 ? (
                            <button
                              className="select_room"
                              onClick={() => AddRoomCart(data)}
                            >
                              Add Room
                            </button>
                          ) : (
                            <button
                              className={
                                data?.available_rooms <= 0
                                  ? "select_room opacityadd"
                                  : "select_room"
                              }
                              onClick={() =>
                                selectRoom(data?._id, data?.available_rooms)
                              }
                            >
                              {t("Select_Room")}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            <div class="row">
              {notAvailable &&
                notAvailable.map((data) => (
                  <div className="col-sm-4">
                    <div className="main_room_image flt">
                      <div className="room_image flt">
                        <img
                          src={
                            data?.room_image[0]
                              ? `${process.env.REACT_APP_MEDIA_DOMAIN}${data?.room_image?.[0]}`
                              : sample
                          }
                          alt="no_image"
                        />

                        <div className="main_standerd not_available_rooom flt">
                          {data?.room_type} is not available
                        </div>
                      </div>
                    </div>
                    {/* <div class="not_available_rooom">
                      <b>{data.room_type}</b> is not available
                    </div> */}
                  </div>
                ))}
            </div>
            {/* {!roomList && (
              <div>
                No individual rooms are available for the selected number of
                adults. Please select the appropriate room count.
              </div>
            )} */}
          </div>
        )}

        {roomsDatassss &&
          user_id &&
          startTime == cartData?.arrival_date &&
          endTime == cartData?.departure_date && (
            <div className="cart_details flt">
              <div className="cards_contentss">
                {roomsDatassss
                  ?.filter((_, index) => index % differenceDate === 0)
                  .map((room, index) => (
                    <div className="cart_cardss" key={index}>
                      <img
                        src={close}
                        onClick={() => deleteRoom(roomsDatassss, index)}
                      />
                      <img
                        className="editOption"
                        src={add_shopping_cart}
                        onClick={() => editDetails(roomsDatassss, index, room)}
                      />
                      <div className="room_no">Room {index + 1}</div>
                      <div className="room_name">{room.room_type}</div>
                      <div className="adult_count">
                        {room.actualAdultCount} Adults, {room.infants.length}{" "}
                        Children
                      </div>
                      <div className="cost">
                        Price:{" "}
                        <span>
                          ₹{" "}
                          {commaValidation(
                            Number(
                              (room.roomCharge + room.gst) * differenceDate
                            ).toFixed(2)
                          )}
                        </span>
                      </div>
                    </div>
                  ))}
              </div>
              <div className="procedBtn">
                <button
                  className="select_room"
                  onClick={() => proceedBtn(true)}
                >
                  Proceed Booking
                </button>
              </div>
            </div>
          )}
        <Modal
          open={removeRooms}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="modal_container"
        >
          <div
            className="view_details_popup  gsdgsdfg"
            key={modalRenderTrigger}
          >
            <div className="view_details_header">
              {/* <p className="heading">Select who will stay in Room</p> */}

              <div className="options">
                {/* <div className="option" onClick={addMoreRooms}>
                  <img src={add_shopping_cart2} />
                  <p className="addMoreRoom">Add More Rooms</p>
                </div> */}
                <img
                  src={close}
                  onClick={() =>
                    updateClicked
                      ? closeModalEdit(selectAdultEdit, selectChildrenEdit)
                      : closeModal()
                  }
                />
                {/* <img onClick={closeModal} /> */}
              </div>
            </div>
            <div className="main_guest_adultsbb flt">
              {/* {adultcount.map((data, i) => ( */}
              <div className="couuuntss flt">
                <div className="guest_adults flt">
                  <div className="main_adult_img home_count">
                    {/* <div className="roomCounttt">{i + 1}</div> */}
                    {/* <div className="person_count">Room{i + 1}</div> */}
                    <div className="person_count">Total Adults</div>
                  </div>

                  <div className="main_increment">
                    <select
                      name="item"
                      value={adultcount}
                      // value={
                      //   adultcount
                      //     ? adultcount
                      //     : selectedAdultCount > 3
                      //     ? 3
                      //     : selectedAdultCount
                      // }
                      onChange={handleChangeAdult}
                    >
                      <option selected disabled>
                        Select Adult count
                      </option>
                      {Array.from(
                        {
                          length:
                            adultLengthDisplay >= tempAdultCount
                              ? adultLengthDisplay
                              : tempAdultCount - tempRoomCount + 1 < 3
                              ? tempAdultCount - tempRoomCount + 1
                              : 3,
                        },
                        (_, index) => (
                          <option key={index + 1} value={index + 1}>
                            {index + 1}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                  <div className="main_adult_img home_count">
                    {/* <div className="roomCounttt">{i + 1}</div> */}
                    {/* <div className="person_count">Room{i + 1}</div> */}
                    <div className="person_count">Total Children</div>
                  </div>
                  <div className="main_increment">
                    <select
                      name="item"
                      value={
                        childrenCount <= 2
                          ? childrenCount
                          : selectedChildrenCount > 2
                          ? 2
                          : selectedChildrenCount
                      }
                      onChange={handleChange}
                    >
                      <option selected disabled>
                        Select Children count
                      </option>
                      {Array.from(
                        {
                          length:
                            childrenLengthDisplay >= selectedChildrenCount
                              ? Number(childrenLengthDisplay) + 1
                              : selectedChildrenCount > 2
                              ? 3
                              : Number(selectedChildrenCount) + 1,
                        },
                        (_, index) => (
                          <option key={index} value={index}>
                            {index}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                </div>
                {/* <button
                    className="room_remove"
                    onClick={() => handleDelete()}
                  >
                    <img src={delete_img} />
                  </button> */}
              </div>
              {childrenCount && (
                <div className="selectAge">Select Children Age</div>
              )}
              <div className="childrenAge">
                {Array.from(
                  {
                    length:
                      childrenCount <= 2
                        ? childrenCount
                        : selectedChildrenCount > 2
                        ? 2
                        : Number(selectedChildrenCount),
                  },
                  (_, index) => (
                    <select
                      key={index}
                      name={`child-${index}`}
                      value={childrenAges[index]}
                      onChange={(event) => handleChildAgeChange(index, event)}
                    >
                      <option selected>Select Child {index + 1} Age</option>
                      {(Array.isArray(childArrayAge)
                        ? childArrayAge
                        : JSON.parse(childArrayAge || "[]")
                      )?.map((age, i) => (
                        <option key={i} value={age}>
                          {age}
                        </option>
                      ))}
                    </select>

                    // <select
                    //   key={index}
                    //   name={`child-${index}`}
                    //   value={childrenAges[index]}
                    //   onChange={(event) => handleChildAgeChange(index, event)}
                    // >
                    //   <option selected disabled>
                    //     Select Child {index + 1} Age
                    //   </option>
                    //   <option value="0">0</option>
                    //   <option value="1">1</option>
                    //   <option value="2">2</option>
                    //   <option value="3">3</option>
                    //   <option value="4">4</option>
                    //   <option value="5">5</option>
                    //   <option value="6">6</option>
                    //   <option value="7">7</option>
                    //   <option value="8">8</option>
                    //   <option value="9">9</option>
                    //   <option value="10">10</option>
                    //   <option value="11">11</option>
                    //   <option value="12">12</option>
                    //   <option value="13">13</option>
                    //   <option value="14">14</option>
                    //   <option value="15">15</option>
                    //   <option value="16">16</option>
                    //   <option value="17">17</option>
                    // </select>
                  )
                )}
              </div>
              {childAgeSelected && (
                <div className="validation_required">
                  {/* <i
                    class="fa-solid fa-circle-exclamation"
                    style="color: #ed0707;"
                  ></i> */}
                  Please Select Children Age..
                </div>
              )}
              <div>
                {!updateClicked && (
                  <button className="select_room addRoomBtn" onClick={addRoom}>
                    Add
                  </button>
                )}
                {updateClicked && (
                  <button
                    className="select_room addRoomBtn"
                    onClick={updateRoom}
                  >
                    Update
                  </button>
                )}
              </div>
              {/* ))} */}
            </div>
          </div>
        </Modal>
      </div>
    );
  };
  return (
    <div className="main_container">
      {renderTopBar()}
      {/* {renderVegasBar()} */}
      {renderMainRoom()}
    </div>
  );
};

export default withTranslation()(Home);
